
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { sEntrys } from '../TitleList';
import { errorStyles } from '../../Utils/table';
import { useDispatch, useSelector } from 'react-redux';
import { createSamplePriceEntry } from '../../Store/PHPSlice/SamplePrice';
import SampleTable from '../MasterTables/SampleTable/SampleTable';
import { selectFirm, selectlocationdata } from '../Selectors/Master/ItemSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchLocationData } from '../../Store/PHPSlice/Transport';


const SampleEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        locId: '',
        firmId: '',
        grpNm: '',
        price:'',
        userId: userdata?.ID
    });
    const dispatch = useDispatch();

    const firmlist = useSelector(selectFirm);
    const loclist = useSelector(selectlocationdata);
    

    useEffect(() => {
        dispatch(fetchCompanyData());
        dispatch(fetchLocationData());
    }, [dispatch]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    const [errors, setErrors] = useState({});
    const handleSubmit = (event) => {
        event.preventDefault();
        // console.log(formData);
        // Validate department name
        if (!formData.grpNm.trim()) {
            setErrors({ grpNm: 'Group Name is required' });
            return;
        }
         if (!formData.price.trim()) {
            setErrors({ grpNm: 'Price is required' });
            return;
        }

        // if (!formData.firmId.trim()) {
        //     setErrors({ firmId: 'Firm is required' });
        //     return;
        // }


        dispatch(createSamplePriceEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Sample Price Added");
               window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };


    const dropdownFirm = [
        // {
        //     label: 'Firm',
        //     id: 'firmId',
        //     options: firmlist?.data || [],
        //     value: formData.firmId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
        //     getOptionLabel: (option) => option.firmNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     errors: errors.firmId
        // },
        {
            label: 'Location',
            id: 'locId',
            options: loclist?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            errors: errors.firmId
        }
    ];

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };



    return (
        <>
            <Titlebar data={sEntrys} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Sample Price Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={0.5}>

                                {/* {dropdownFirm?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        errors={drop.errors}
                                    />
                                ))
                                } */}

                                <Grid item xs={12} md={6} >
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='rackNm' >Group Name:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth error={!!errors.rackNm}>
                                                <TextField
                                                    id='grpNm'
                                                    name='grpNm'
                                                    value={formData.grpNm}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.input }}
                                                    sx={inputStyles}

                                                />
                                                {errors.grpNm && <FormHelperText style={errorStyles}>{errors.grpNm}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                        
                                    </Grid>
                                </Grid>
                                   <Grid item xs={12} md={6} >
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='rackNo' >Price:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth error={!!errors.price}>
                                                <TextField
                                                    id='price'
                                                    name='price'
                                                    value={formData.price}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.input }}
                                                    sx={inputStyles}

                                                />
                                                {errors.price && <FormHelperText style={errorStyles}>{errors.price}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                        
                                    </Grid>
                                </Grid>
                                
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
                <SampleTable />

            </div>
        </>
    );
}

export default SampleEntry;
